import { createDataHooks } from '@wix/premium-fed-sdk/test-utils';
export const FaqsDataHooks = createDataHooks('faqs', 'question', 'answer');
//# sourceMappingURL=dataHooks.js.map